<template>
  <span class="popover-wrapper">
    <div class="popover" ref="popover" :class="variation" v-show="!disabled && showPopper">
      <div class="popover-content">
        <div v-show="hasHeaderSlot()" class="popover-header">
          <slot name="header">{{ content }}</slot>
        </div>
        <div v-show="hasBodySlot()" class="popover-body">
          <slot name="body">{{ content }}</slot>
        </div>
      </div>
    </div>

    <slot name="reference"></slot>
  </span>
</template>

<style lang="scss">
@import '../assets/scss/micron/imports';

$popover-bg-color: #fff;
$popover-bg-dark: $body-font-color;
$popover-arrow-size: 10px;

.popover-wrapper {
  position: relative;
}

.popover {
  position: absolute;
  width: auto;
  min-width: 300px;
  max-width: 600px;
  text-align: center;
  z-index: 1500;
  border: none;

  .popover-content {
    margin: -1px;
    min-width: 300px;
    max-height: 400px;
    overflow: hidden;
    overflow-y: visible;
    background-color: $popover-bg-color;
    border-radius: 3px;
    box-shadow: rgba(0, 0, 0, 0.3) 0 0 15px 0;
  }
  .popover-header {
    text-transform: uppercase;
    color: #fff;
  }
  .popover-body {
    padding: 0;

    .list-group {
      .list-group-item {
        border: none;
        margin-bottom: 0;
        border-bottom: 1px solid $mn-white-smoke;

        time {
          display: block;
          font-weight: bold;
          color: $body-font-color;
        }
        // TODO: This h6 and col is temp since there no actual design it might go away
        h6 {
          margin: 0;
          text-transform: uppercase;
          //white-space: nowrap;
          font-size: 10px;
        }
        .col {
          line-height: normal;
        }

        a {
          border-radius: 0;

          &:hover {
            color: $body-font-color;
          }
        }
      }
      .list-group-item-action {
        text-align: center;
        font-size: 1rem;

        &,
        &.mn-btn,
        &.link {
          display: block;
          padding: rem(12px) rem(20px);
          border-bottom: 1px solid $mn-white-smoke;
          &:last-child {
            border-bottom: none;
          }
        }

        &.mn-btn {
          margin: 0;
        }

        &.link {
          border-radius: 0;
        }

        &:focus {
          &:active {
            outline: 0;
          }
        }

        &:active {
          transform: none;
        }
      }
    }
  }
  .popover-arrow {
    position: absolute;
    margin: $popover-arrow-size;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: $popover-arrow-size;
    border-color: transparent;
  }

  // Arrows
  &[x-placement^='top'] {
    margin-bottom: $popover-arrow-size + 5;
    .popover-arrow {
      border-bottom-width: 0;
      border-top-color: $popover-bg-color;
      bottom: -$popover-arrow-size;
      left: calc(50% - #{$popover-arrow-size});
      margin-top: 0;
      margin-bottom: 0;
    }
    &.dark {
      .popover-arrow {
        border-top-color: $popover-bg-dark;
      }
    }
  }

  &[x-placement^='bottom'] {
    margin-top: $popover-arrow-size + 5;
    .popover-arrow {
      border-top-width: 0;
      border-bottom-color: $popover-bg-color;
      top: -$popover-arrow-size;
      left: calc(50% - #{$popover-arrow-size});
      margin-top: 0;
      margin-bottom: 0;
    }
    &.dark {
      .popover-arrow {
        border-bottom-color: $popover-bg-dark;
      }
    }
  }

  &[x-placement^='right'] {
    margin-left: $popover-arrow-size + 5;
    .popover-arrow {
      border-left-width: 0;
      border-right-color: $popover-bg-color;
      left: -$popover-arrow-size;
      top: calc(50% - #{$popover-arrow-size});
      margin-left: 0;
      margin-right: 0;
    }
    &.dark {
      .popover-arrow {
        border-right-color: $popover-bg-dark;
      }
    }
  }

  &[x-placement^='left'] {
    margin-right: $popover-arrow-size + 5;
    .popover-arrow {
      border-right-width: 0;
      border-left-color: $popover-bg-color;
      right: -$popover-arrow-size;
      top: calc(50% - #{$popover-arrow-size});
      margin-left: 0;
      margin-right: 0;
    }
    &.dark {
      .popover-arrow {
        border-left-color: $popover-bg-dark;
      }
    }
  }

  // Dark Theme
  &.dark {
    .popover-content {
      color: #fff;
      background-color: $popover-bg-dark;

      a {
        color: #fff;
      }
    }
    .popover-body {
      color: #fff;
    }
  }

  &.content-center {
    text-align: center;
  }
}
</style>

<script>
import Popper from 'popper.js'
import Vue from 'vue'

export default Vue.extend({
  name: 'PopOver',
  props: {
    variation: {
      // 'dark'
      type: String,
      default: '',
    },
    trigger: {
      type: String,
      default: 'click',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    content: String,
    popover: {},
    header: {},
    body: {},
    reference: {},
    forceShow: {
      type: Boolean,
      default: false,
    },
    closeOnClick: {
      type: Boolean,
      default: false,
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      refEl: null,
      popperJS: null,
      showPopper: false,
      currentPlacement: '',
      popperOptions: {
        placement: 'bottom',
      },
    }
  },
  watch: {
    showPopper(value) {
      if (value) {
        this.updatePopper()
      }
    },
    forceShow: {
      handler(value) {
        this[value ? 'doShow' : 'doClose']()
      },
      immediate: true,
    },
    disabled(value) {
      if (value) {
        this.showPopper = false
      }
    },
  },
  created() {
    this.appendedArrow = false
    this.appendedToBody = false
    this.popperOptions = Object.assign(this.popperOptions, this.options)
  },
  mounted() {
    this.refEl = this.reference || this.$slots.reference[0].elm
    this.popper = this.$refs.popover
    this.attachListener(this.refEl, 'click', this.doToggle)
    this.attachListener(document, 'click', this.handleDocumentClick)
  },
  methods: {
    hasHeaderSlot() {
      return !!this.$slots.header
    },
    hasBodySlot() {
      return !!this.$slots.body
    },
    doToggle(event) {
      if (!this.forceShow) {
        this.showPopper = !this.showPopper
      }
    },
    doShow() {
      this.showPopper = true
    },
    doClose() {
      this.showPopper = false
    },
    doDestroy() {
      if (this.showPopper) {
        return
      }
      if (this.popperJS) {
        this.popperJS.destroy()
        this.popperJS = null
      }
      if (this.appendedToBody) {
        this.appendedToBody = false
        document.body.removeChild(this.popper.parentElement)
      }
    },
    createPopper() {
      this.$nextTick(() => {
        this.appendArrow(this.popper)
        if (this.appendToBody && !this.appendedToBody) {
          this.appendedToBody = true
          document.body.appendChild(this.popper.parentElement)
        }
        if (this.popperJS && this.popperJS.destroy) {
          this.popperJS.destroy()
        }
        this.popperOptions.onCreate = () => {
          this.$nextTick(this.updatePopper)
        }
        this.popperJS = new Popper(this.refEl, this.popper, this.popperOptions)
      })
    },
    destroyPopper() {
      this.removeListener(this.refEl, 'blur', this.doClose)
      this.removeListener(document, 'click', this.handleDocumentClick)
      this.showPopper = false
      this.doDestroy()
    },
    appendArrow(element) {
      if (this.appendedArrow) {
        return
      }
      this.appendedArrow = true
      const arrow = document.createElement('div')
      arrow.setAttribute('x-arrow', '')
      arrow.className = 'popover-arrow'
      element.appendChild(arrow)
    },
    updatePopper() {
      this.popperJS ? this.popperJS.scheduleUpdate() : this.createPopper()
    },
    handleDocumentClick(e) {
      if (!this.$el || !this.refEl || this.elementContains(this.refEl, e.target)) {
        return
      }
      if (!this.closeOnClick) {
        if (
          this.elementContains(this.$el, e.target) ||
          !this.popper ||
          this.elementContains(this.popper, e.target)
        ) {
          return
        }
      }
      if (this.forceShow) {
        return
      }
      this.showPopper = false
    },
    elementContains(elm, otherElm) {
      if (typeof elm.contains === 'function') {
        return elm.contains(otherElm)
      }
      return false
    },
    attachListener(element, event, handler) {
      if (element && event && handler) {
        document.addEventListener
          ? element.addEventListener(event, handler, false)
          : element.attachEvent('on' + event, handler)
      }
    },
    removeListener(element, event, handler) {
      if (element && event) {
        document.removeEventListener
          ? element.removeEventListener(event, handler, false)
          : element.detachEvent('on' + event, handler)
      }
    },
  },
  destroyed() {
    this.destroyPopper()
  },
})
</script>
